import { useCallback, useEffect, useState } from 'react'
import {
  getSoundsEnabled,
  onSoundsChanged,
  setSoundsEnabled as storeSoundsEnabled,
} from '../lib/sounds/soundSetting'

/**
 * Sound an/aus für den Schalter in den Einstellungen — in Electron derselbe
 * Wert wie der Haken im Tray-Menü, im Web merkt ihn sich der Browser
 * (`lib/sounds/soundSetting`).
 *
 * Folgt jeder Änderung, damit der Schalter umspringt, wenn jemand im Tray
 * oder in einem anderen Tab umschaltet, während die Einstellungen offen sind.
 */
export function useSoundsEnabled(): {
  soundsEnabled: boolean
  setSoundsEnabled: (enabled: boolean) => void
} {
  const [soundsEnabled, setLocal] = useState(true)

  useEffect(() => {
    let abgemeldet = false
    const abmelden = onSoundsChanged(enabled => {
      if (!abgemeldet) setLocal(enabled)
    })
    void getSoundsEnabled().then(enabled => { if (!abgemeldet) setLocal(enabled) })
    return () => {
      abgemeldet = true
      abmelden()
    }
  }, [])

  const setSoundsEnabled = useCallback((enabled: boolean) => {
    setLocal(enabled)
    storeSoundsEnabled(enabled)
  }, [])

  return { soundsEnabled, setSoundsEnabled }
}
